import React from "react";

const config = {
  success: {
    wrapper: "border-[rgba(16,185,129,0.3)]",
    icon: "bg-[rgba(16,185,129,0.12)] text-emerald-400",
    svg: <polyline points="20 6 9 17 4 12" />,
  },
  error: {
    wrapper: "border-[rgba(239,68,68,0.3)]",
    icon: "bg-[rgba(239,68,68,0.12)] text-red-400",
    svg: (
      <>
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </>
    ),
  },
  info: {
    wrapper: "border-[rgba(59,130,246,0.3)]",
    icon: "bg-[rgba(59,130,246,0.12)] text-blue-400",
    svg: (
      <>
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </>
    ),
  },
  warning: {
    wrapper: "border-[rgba(251,191,36,0.3)]",
    icon: "bg-[rgba(251,191,36,0.12)] text-yellow-400",
    svg: (
      <>
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </>
    ),
  },
};

export function ToastAlert({ type = "success", message }) {
  const selected = config[type] || config.success;
  const { wrapper, icon, svg } = selected;

  return (
    <div
      className={`
        flex items-center gap-3 px-5 py-3.5
        rounded-xl border
        bg-[rgba(3,0,33,0.97)]
        backdrop-blur-md
        shadow-[0_8px_32px_rgba(0,0,0,0.4)]
        text-white text-sm font-medium
        font-['DM_Sans',sans-serif]
        ${wrapper}
      `}
    >
      <div
        className={`
          w-8 h-8 min-w-[32px] rounded-lg
          flex items-center justify-center
          ${icon}
        `}
      >
        <svg
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          {svg}
        </svg>
      </div>

      <span>{message}</span>
    </div>
  );
}
